const marka = { t: 'Marka', name: 'marka', hint: { url: '/make/trailer', cache: 'trail-make', exact: true }}
export default marka